import styled from 'styled-components';

const Text = styled.span`
  padding-left: 4px;
  font-size: 13px;
  line-height: 14px;
`;

export default Text;
